import axiosInstance from '../axiosInterceptor/axiosInstance'
import selectedOrgId from '../../utils/helpers/selectedOrgId'

export const deleteCourt = async (data) => {
  const { courtId } = data
  const url = `v1/orgs/${selectedOrgId()}/courts/${courtId}`

  return await axiosInstance.delete(url)
}
